/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import classes from "../createPackage/createPackage.module.css";
import Input from "../../../component/inputpm";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Card, Icon, TableContainer } from "@mui/material";
import {
  AcceptIcon,
  CancelIcon,
  ClearIcon,
  DeleteIconNew,
  PlusIcon,
  RefreshIcon,
} from "../../../component/icons/icons";
import Button from "../../../component/button";

const ActivationResourcesTable = (props) => {
  const { t } = props;
  const [typeList] = useState([
    { value: "string", name: "String" },
    { value: "email", name: "Email" },
    { value: "number", name: "Number" },
    { value: "decimal", name: "Decimal" },
    { value: "date", name: "Date" },
    { value: "datetime", name: "Datetime" },
    { value: "boolean", name: "Boolean" },
  ]);
  const setResourceType = (val) => {
    for (var i = 0; i < typeList.length; i++) {
      if (val === typeList[i].value) {
        return typeList[i].name;
      }
    }
  };
  return (
    <>
      {props.activationParams.length > 0 && (
        <>
          <div className={classes.activationResourceContainer}>
            <div
              style={{
                padding: "1rem",
                display: "flex",
                justifyContent: "space-between",
                marginRight: "1rem",
              }}
            >
              {(props.activationParamEditable ||
                props.activationParams.length > 0) && (
                <b style={{ alignContent: "center" }}>
                  {props.type} {t("PARAMETERS")}
                </b>
              )}
              <span>
                {props.activationParamEditable && (
                  <>
                    {props.readonly ||
                    props.statusDisplayName === "Published" ? (
                      ""
                    ) : (
                      <Tooltip title="Add Parameter">
                        <IconButton
                          className="buttonSecondary"
                          aria-label="Add Parameter"
                          component="span"
                          onClick={(e) => {
                            props.addActivationParam();
                          }}
                        >
                          <PlusIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                )}
              </span>
            </div>
            <Grid
              item
              size={{
                xs: 12,
              }}
            ></Grid>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              {props.activationParams.length > 0 && (
                <Card
                  variant="outlined"
                  style={{
                    borderRadius: "8px",
                    marginBottom: "1rem",
                    marginLeft: "1rem",
                    marginRight: "1rem",
                  }}
                >
                  <TableContainer>
                    <Table className="newGlobalTable roundCorners">
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <b>{t("LABEL")}</b>
                          </TableCell>
                          <TableCell>
                            <b>{t("TYPE")}</b>
                          </TableCell>
                          {props.showDefaultValue && (
                            <TableCell>
                              <b>{t("VALUE")}</b>
                            </TableCell>
                          )}
                          <TableCell>
                            <b>{t("REGEX")}</b>
                          </TableCell>
                          {props.activationParamEditable && (
                            <TableCell></TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.activationParams.map((item, i) =>
                          props.activationParamEditable ? (
                            <TableRow key={i}>
                              <TableCell>
                                <Input
                                  name="label"
                                  variant={"outlined"}
                                  divClass={classes.customDiv}
                                  size={"small"}
                                  value={item.label}
                                  onChange={(e) =>
                                    props.changeActivationParam(i, e)
                                  }
                                  disabled={
                                    props.readonly ||
                                    props.statusDisplayName === "Published"
                                  }
                                />
                              </TableCell>
                              <TableCell>
                                <FormControl variant="outlined" size={"small"}>
                                  <Select
                                    value={item.type}
                                    native
                                    inputProps={{
                                      name: "type",
                                      id: "type",
                                    }}
                                    onChange={(e) =>
                                      props.changeActivationParam(i, e)
                                    }
                                    disabled={
                                      props.readonly ||
                                      props.statusDisplayName === "Published"
                                    }
                                  >
                                    <option value="string">
                                      {t("STRING")}
                                    </option>
                                    <option value="email">{t("EMAIL")}</option>
                                    <option value="number">
                                      {t("NUMBER")}
                                    </option>
                                    <option value="decimal">
                                      {t("DECIMAL")}
                                    </option>
                                    <option value="date">{t("DATE")}</option>
                                    <option value="datetime">
                                      {t("DATETIME")}
                                    </option>
                                    <option value="boolean">
                                      {t("BOOLEAN")}
                                    </option>
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <Input
                                  name="validation"
                                  variant={"outlined"}
                                  divClass={classes.customDiv}
                                  size={"small"}
                                  value={item.validation}
                                  onChange={(e) =>
                                    props.changeActivationParam(i, e)
                                  }
                                  disabled={
                                    props.readonly ||
                                    props.statusDisplayName === "Published"
                                  }
                                />
                              </TableCell>
                              <TableCell>
                                {/* {props.readonly ? '' :
                                                    <IconButton className='buttonSecondary' onClick={(e) => { props.removeActivationParam(i) }}> <DeleteIconNew/> </IconButton>
                                                } */}
                                {
                                  <div
                                    align="right"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: ".25rem",
                                    }}
                                  >
                                    {props.readonly ||
                                    props.statusDisplayName === "Published" ? (
                                      ""
                                    ) : (
                                      <>
                                        <IconButton
                                          className="buttonSecondary"
                                          onClick={(e) => {
                                            props.removeActivationParam(i);
                                          }}
                                        >
                                          {" "}
                                          <DeleteIconNew />{" "}
                                        </IconButton>
                                        {props.mode === "edit" ? (
                                          <>
                                            <IconButton
                                              className="buttonSecondary"
                                              onClick={props.cancelEdit}
                                            >
                                              {" "}
                                              <ClearIcon />{" "}
                                            </IconButton>
                                            <IconButton
                                              className="buttonSecondary"
                                              onClick={props.submitData}
                                            >
                                              {" "}
                                              <RefreshIcon />{" "}
                                            </IconButton>
                                          </>
                                        ) : (
                                          props.activationParams.length > 0 && (
                                            <IconButton
                                              className="buttonSecondary"
                                              onClick={props.submitData}
                                            >
                                              <PlusIcon />
                                            </IconButton>
                                          )
                                        )}
                                      </>
                                    )}
                                  </div>
                                }
                              </TableCell>
                            </TableRow>
                          ) : (
                            <TableRow key={i}>
                              <TableCell>{item.label}</TableCell>
                              <TableCell>
                                {setResourceType(item.type)}
                              </TableCell>
                              {props.showDefaultValue && (
                                <TableCell>{item.value}</TableCell>
                              )}
                              <TableCell>{item.validation}</TableCell>
                            </TableRow>
                          ),
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
              )}
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(
  withTranslation("translations")(ActivationResourcesTable),
);
